<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'update',
  },
  props: {
    id: {
      type: String,
      default: null,
      validator(value) {
        return /^[a-zA-Z][\w:.-]*$/.test(value)
      },
    },
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'checkbox',
      validator(value) {
        return ['radio', 'checkbox'].includes(value)
      },
    },
    checked: {
      type: [Number, Boolean],
      default: false,
    },
  },
  computed: {
    proxyChecked: {
      get() {
        return this.checked
      },
      set(val) {
        this.$emit('update', val)
      },
    },
  },
}
</script>

<template>
  <label :for="id" class="inline-flex items-center cursor-pointer">
    <slot name="icons" />
    <span>
      <input
        :id="id"
        v-model="proxyChecked"
        :class="type"
        :type="type"
        :name="name"
        class="mr-2"
        v-bind="$attrs"
        v-on="$listeners"
      />
      <span v-if="label">
        {{ label }}
      </span>
    </span>
  </label>
</template>
